/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit GreyfinchBird/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function GreyfinchBird({
  children,
  viewPath = "/DesignSystem/Svgs/GreyfinchBird",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 200,
  height = 132,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#00BC70"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="GreyfinchBird.Svg"
  data-view-path={viewPath}
 viewBox="0 0 200 132"
 style={{'--as-1-ZBSIaB': alignSelf,'--mt-2-ZBSIaB': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZBSIaB': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZBSIaB': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZBSIaB': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZBSIaB': opacity,'--w-10-ZBSIaB': typeof width === 'number' ? `${width}px` : width,'--h-11-ZBSIaB': typeof height === 'number' ? `${height}px` : height,'--f-12-ZBSIaB': fill,'--a-7-ZBSIaB': isAnimated ? animation : "none",'--sd-8-ZBSIaB': isAnimated ? strokeDashoffset : 0,'--sd-9-ZBSIaB': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="GreyfinchBird.SvgPath"
  data-view-path={viewPath}
 d="M119.297 58.86c5.557-.07 9.508-5.87 22.29-8.987C154.042 33.533 156.965 8.32 156.261 6.6c-.697-1.727-47.482 19.193-56.612 42.51-.92 2.353 15.505 9.802 19.648 9.75z"
 style={{'--f-12-ZBSIaB': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="GreyfinchBird.SvgPath:1"
  data-view-path={viewPath}
 d="M125.472 60.675c-1.618.984-3.227 2.121-5.037 2.29-1.811.162-3.884-.622-5.919-1.464-36.535-15.213-66.49-36.149-74.828-43.478-8.331-7.335-34.603 49.464 13.58 69.612C64.85 92.472 70.044 96.12 68.045 97.6c-5.415 3.998-48.569 16.201-59.34 16.603-3.32.118 2.405 5.722 5.29 5.844 3.018.129 22.588-4.235 40.643-5.049 8.197-.366 20.699 2.038 25.559 3.644 17.976 5.95 37.778-3.345 55.549-18.413 17.772-15.064 18.217-15.942 23.206-19.877 24.115-19.019 34.099-11.097 35.437-14.025 1.346-2.928-30.789-28.916-68.917-5.651z"
 style={{'--f-12-ZBSIaB': fill2}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}